import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { contentHeadlineTagContent$key } from "~/queries/__generated__/contentHeadlineTagContent.graphql";

import { useDetermineHeadlineTag } from "./hooks";
import { Description, Flag, Heading, StyledTooltip } from "./styles";

export type Props = {
  hideTooltip?: boolean;
  reference: contentHeadlineTagContent$key;
  useSectionTags?: boolean;
};

export const ContentHeadlineTag: FunctionComponent<Props> = ({
  hideTooltip,
  reference: reference_,
  useSectionTags = false,
}) => {
  const content = useFragment(
    graphql`
      fragment contentHeadlineTagContent on Content {
        ...hooksContentHeadlineTagContent
      }
    `,
    reference_,
  );
  const headlineTag = useDetermineHeadlineTag(content, useSectionTags);
  if (!headlineTag || !headlineTag.name) return null;

  const handleRenderFlag = () => <Flag color={headlineTag.color}>{headlineTag.name}</Flag>;
  if (hideTooltip || !headlineTag.description) return handleRenderFlag();

  return (
    <StyledTooltip
      placement="bottom-start"
      title={
        <>
          {headlineTag.name && <Heading>{headlineTag.name}</Heading>}
          {headlineTag.description && <Description>{headlineTag.description}</Description>}
        </>
      }
      arrow
    >
      {handleRenderFlag()}
    </StyledTooltip>
  );
};

ContentHeadlineTag.displayName = "ContentHeadlineTag";
